import React, { Component } from 'react';
import ReCAPTCHA from 'react-google-recaptcha';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { adminRecuperarClaveEmail } from '../../store/actions';
import { Regex, Validate, RegexExtra, Config } from '../../other';
import { Grid, withStyles } from '@material-ui/core';
import {
  PublicLayout,
  InputUI,
  ButtonUI,
  AlertUI,
  ToggleUI,
  CardModuleUI,
} from '../common';

class RecuperarClaveEmail_ extends Component {
  recaptchaRef = React.createRef();

  state = {
    recuperar_clave_email: {
      t_email: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'email',
        label: 'Email',
        id: 't_email',
        name: 't_email',
        change_param: 'recuperar_clave_email',
        regex: Regex.EMAIL,
        value: '',
        default_value: '',
        placeholder: 'algo@algo.com',
        messages: {
          error: 'Por favor, ingrese un email válido',
          error_extra: RegexExtra.EMAIL,
        },
      },
      t_clave: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'password',
        label: 'Nueva clave',
        id: 't_clave',
        name: 't_clave',
        change_param: 'recuperar_clave_email',
        regex: Regex.CLAVE,
        value: '',
        default_value: '',
        placeholder: '******',
        messages: {
          error: 'Por favor, ingrese una clave válida',
          error_extra: RegexExtra.CLAVE,
        },
      },
      t_repetir_clave: {
        auth: false,
        validate: true,
        required: true,
        disabled: false,
        error: false,
        type: 'password',
        label: 'Repetir clave',
        id: 't_repetir_clave',
        name: 't_repetir_clave',
        change_param: 'recuperar_clave_email',
        regex: Regex.CLAVE,
        value: '',
        default_value: '',
        placeholder: '******',
        messages: {
          error: 'Por favor, ingrese una clave válida',
          error_extra: RegexExtra.CLAVE,
        },
      },
      t_codigo_clave: {
        validate: false,
        value: '',
      },
    },
    after: false,
    forms: {
      recuperar_clave_email: false,
    },
    recaptcha_state: false,
    alert: {
      open: false,
      type: 'error',
      message: '',
    },
  };

  componentDidMount() {
    let t_codigo_clave = this.props.match.params.token;
    if (t_codigo_clave.length === 64) {
      this.setState({
        recuperar_clave_email: {
          ...this.state.recuperar_clave_email,
          t_codigo_clave: {
            ...this.state.recuperar_clave_email.t_codigo_clave,
            value: t_codigo_clave,
          },
        },
      });
    } else {
      this.props.history.push('/login');
    }
  }

  handleChange = (e, blur, aditional) => {
    let value = e.target.value;
    let name = e.target.name;

    this.setState(
      {
        [aditional]: {
          ...this.state[aditional],
          [name]: {
            ...this.state[aditional][name],
            value: value,
          },
        },
      },
      () => {
        Validate.validate_input(this.state[aditional][name], blur, (input) => {
          this.setState({
            [aditional]: {
              ...this.state[aditional],
              [name]: input,
            },
          });
        });
      }
    );
  };

  handleCloseAlert = () => {
    this.setState({
      alert: {
        ...this.state.alert,
        open: false,
      },
    });
  };

  handleSubmit = (t_captcha) => {
    this.setState(
      {
        forms: {
          ...this.state.forms,
          recuperar_clave_email: true,
        },
        recaptcha_state: false,
      },
      () => {
        if (t_captcha) {
          let form = this.state.recuperar_clave_email;

          if (Validate.validar_formulario(form)) {
            if (form.t_clave.value === form.t_repetir_clave.value) {
              this.props.adminRecuperarClaveEmail(
                {
                  t_email: form.t_email.value,
                  t_clave: form.t_clave.value,
                  t_codigo_clave: form.t_codigo_clave.value,
                  t_captcha: t_captcha,
                },
                (err, resp) => {
                  if (err) {
                    this.setState(
                      {
                        forms: {
                          ...this.state.forms,
                          recuperar_clave_email: false,
                        },
                        alert: {
                          ...this.state.alert,
                          open: true,
                          message: resp.message,
                        },
                      },
                      () => this.resetRecaptcha()
                    );
                  } else {
                    this.setState({
                      alert: {
                        open: true,
                        type: 'success',
                        message: resp.message,
                      },
                      after: true,
                    });
                  }
                }
              );
            } else {
              this.setState(
                {
                  forms: {
                    ...this.state.forms,
                    recuperar_clave_email: false,
                  },
                  alert: {
                    ...this.state.alert,
                    open: true,
                    message: 'Las claves no coinciden',
                  },
                },
                () => this.resetRecaptcha()
              );
            }
          } else {
            Validate.validar_formulario_actualizar_obj(form, (new_form) => {
              this.setState(
                {
                  forms: {
                    ...this.state.forms,
                    recuperar_clave_email: false,
                  },
                  recuperar_clave_email: new_form,
                },
                () => this.resetRecaptcha()
              );
            });
          }
        } else {
          this.setState(
            {
              forms: {
                ...this.state.forms,
                recuperar_clave_email: false,
              },
              alert: {
                open: true,
                type: 'error',
                message:
                  'Ha ocurrido un error con el captcha, intente nuevamente',
              },
            },
            () => this.resetRecaptcha()
          );
        }
      }
    );
  };

  fireCaptcha = (e) => {
    e.preventDefault();
    this.setState(
      {
        recaptcha_state: true,
      },
      () => this.recaptchaRef.current.execute()
    );
  };

  resetRecaptcha = () => {
    this.setState(
      {
        recaptcha_state: false,
      },
      () => this.recaptchaRef.current.reset()
    );
  };

  render() {
    let { classes } = this.props;
    return (
      <PublicLayout>
        <AlertUI
          open={this.state.alert.open}
          message={this.state.alert.message}
          type={this.state.alert.type}
          handleCloseAlert={this.handleCloseAlert}
        />
        <form onSubmit={this.fireCaptcha}>
          <Grid container spacing={24}>
            <Grid item xs={12}>
              <CardModuleUI big_shadow>
                <div className={classes.card_padding}>
                  <div className={classes.logo_wrapper}>
                    <Link to="/login">
                      <img
                        src="https://dk0k1i3js6c49.cloudfront.net/landingpage/images/v4/empretienda-green-logo.png"
                        alt="Empretienda logo"
                        className={classes.logo}
                      />
                    </Link>
                  </div>
                  <ToggleUI show={!this.state.after}>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.recuperar_clave_email.t_email}
                    />
                    <div className={classes.separator}></div>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.recuperar_clave_email.t_clave}
                    />
                    <div className={classes.separator}></div>
                    <InputUI
                      handleChange={this.handleChange}
                      input={this.state.recuperar_clave_email.t_repetir_clave}
                    />
                    <ReCAPTCHA
                      ref={this.recaptchaRef}
                      size="invisible"
                      sitekey={Config.RECAPTCHA_PUBLIC_KEY}
                      onChange={(token) => this.handleSubmit(token)}
                      onExpired={() => this.resetRecaptcha()}
                      onErrored={() => this.resetRecaptcha()}
                    />
                    <div className={classes.separator}></div>
                    <div className={classes.separator}></div>
                    <ButtonUI
                      type="submit"
                      label="Cambiar contraseña"
                      size="large"
                      border_radius
                      fullWidth={false}
                      isLoading={this.state.forms.recuperar_clave_email}
                      disabled={this.state.recaptcha_state}
                    />
                  </ToggleUI>
                  <ToggleUI show={this.state.after}>
                    <ButtonUI
                      type="link"
                      label="Ir a iniciar sesión"
                      size="large"
                      border_radius
                      fullWidth={false}
                      link="/login"
                    />
                  </ToggleUI>
                </div>
              </CardModuleUI>
            </Grid>
          </Grid>
        </form>
      </PublicLayout>
    );
  }
}

const styles = (theme) => ({
  separator: {
    width: '100%',
    height: '15px',
  },
  card_padding: {
    padding: '10px',
    [theme.breakpoints.up('sm')]: {
      padding: '10px 30px',
    },
  },
  logo_wrapper: {
    marginBottom: '30px',
  },
  logo: {
    width: '250px',
    maxWidth: '100%',
  },
});

const mapStateToProps = null;
const mapDispatchToProps = (dispatch) => {
  return {
    adminRecuperarClaveEmail: (usuario, callback) =>
      dispatch(adminRecuperarClaveEmail(usuario, callback)),
  };
};

export const RecuperarClaveEmail = withStyles(styles)(
  connect(mapStateToProps, mapDispatchToProps)(RecuperarClaveEmail_)
);
